import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './MortgageOffersNotFound.css';

interface IMortgageOffersNotFoundProps {
  mortgageUrl: string;
}

export const MortgageOffersNotFound: React.FC<IMortgageOffersNotFoundProps> = ({ mortgageUrl }) => {
  return (
    <div className={styles['container']} data-testid="MortgageOffersNotFound">
      <div className={styles['image']} />
      <div className={styles['title']}>
        <ArticleHeading4 color="black_100">Нет подходящих предложений от банков и застройщиков</ArticleHeading4>
      </div>
      <ArticleParagraph2 color={'gray60_100'} textAlign={'center'}>
        Воспользуйтесь предложениями от{' '}
        <a className={styles['link']} href={mortgageUrl} target="blank" rel="noreferrer">
          Циан.Ипотеки
        </a>
      </ArticleParagraph2>
    </div>
  );
};
